import ReactDOM from "react-dom/client";
//
import "./input.css";
import App from "./App";

// Save current path before any Auth0 redirect (e.g. silent refresh on reload) so we can restore it after callback
const pathname = typeof window !== "undefined" ? window.location.pathname : "";
if (pathname && !pathname.startsWith("/auth")) {
  sessionStorage.setItem("auth0_return_path", pathname);
}

// ----------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
